module.exports = __webpack_public_path__ + "img/selected2-min.5aacc922.png";